import React, { useContext } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../../context/ThemeContext';
import { Add, Remove } from '@mui/icons-material';
import { Box, TextField } from '@mui/material';
import {  updateAmountMap } from '../../pages/Quotes';
import { setAmountForOneClick } from '../../../store/Slices/orderPositionSlice';
import { setAmountForSymbol } from '../../../store/Slices/amountSlice';

const AmountInput = ({ symbolId }) => {
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId], shallowEqual);
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { darkMode } = useContext(ThemeContext)
    const dispatch = useDispatch()
    const inputVal = useSelector((state) =>
        state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
    );

    const decreaseAmount = (e) => {
        e.stopPropagation();
        const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
        const minAllowed = symbolParameterData?.minimumAmountPerDeal || step;
        const currentAmount = parseFloat(inputVal);

        const newAmount = Math.max(currentAmount - step, minAllowed).toFixed(decimalPlaces);

        updateAmountMap(symbolId, newAmount);
        dispatch(setAmountForOneClick(parseFloat(newAmount)));
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newAmount) }));
    };

    const increaseAmount = (e) => {
        e.stopPropagation();
        const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
        const maxAllowed = symbolParameterData?.maximumAmountPerDeal;
        const currentAmount = parseFloat(inputVal);

        const newAmount = Math.min(currentAmount + step, maxAllowed).toFixed(decimalPlaces);

        updateAmountMap(symbolId, newAmount);
        dispatch(setAmountForOneClick(parseFloat(newAmount)));
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newAmount) }));
    };

    const handleChange = (e) => {
        let value = e.target.value;

        if ((value.match(/\./g) || []).length > 1) {
            return;
        }

        const numValue = parseFloat(value);
        const maxAllowed = symbolParameterData?.maximumAmountPerDeal;

        if (!isNaN(numValue)) {
            if (numValue > maxAllowed) {
                value = maxAllowed.toFixed(decimalPlaces);
            }
        }

        updateAmountMap(symbolId, value);
        dispatch(setAmountForOneClick(parseFloat(value)));
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
    };

    const updatemap = (e) => {
        const raw = e.target.value;
        const value = parseFloat(raw);
        const min = symbolParameterData?.minimumAmountPerDeal;
        const max = symbolParameterData?.maximumAmountPerDeal;
        const isValidStep = Number.isInteger(value / min);
        if (isNaN(value)) return;
        if (value < min || value > max) return;
        if (!isValidStep) return;

        dispatch(setAmountForSymbol({ symbolId, amount: value }));
        updateAmountMap(symbolId, value);
    };


    return (
        <Box sx={{ marginTop: '1px', px: 1, display: "flex", justifyContent: 'center', alignItems: "center", width: 110, height: '25px', backgroundColor: darkMode ? '#2e3338' : 'var(--white)', p: 1, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'} ` }} onClick={(e) => { e.stopPropagation(); }} onDoubleClick={(e) => { e.stopPropagation(); }}>
            <Remove sx={{ cursor: 'pointer', fontSize: '16px', color: darkMode ? 'white' : "gray" }} onClick={decreaseAmount} />
            <TextField value={inputVal} variant="filled" type='number' onChange={handleChange}
                InputProps={{
                    disableUnderline: true,
                    inputProps: {
                        min: symbolParameterData?.minimumAmountPerDeal,
                        max: symbolParameterData?.maximumAmountPerDeal,
                        step: symbolParameterData?.minimumAmountPerDeal
                    }
                }}
                onBlur={updatemap}
                sx={{ '& .MuiFilledInput-root': { backgroundColor: 'transparent', fontSize: '13px'}, '& .MuiFilledInput-input': { padding: 0, px: 1, borderRadius: 0, textAlign: "center", backgroundColor: 'transparent','&:focus': { backgroundColor: 'transparent' ,} } }}
            />
            <Add sx={{ cursor: 'pointer', fontSize: '16px', color: darkMode ? 'white' : "gray" }} onClick={increaseAmount} />
        </Box>
    )
}

export default AmountInput